import { type ComponentPropsWithoutRef } from 'react';
import Modal from '@/components/Modal';
import { BlockButton } from '@/components/BlockButton';
import { showSuccessToast, showErrorToast } from '../../job_change_processes/lib/toast';
import useDeleteCompany from '../api/useDeleteCompany';

type Props = {
  companyId: number;
  availableProvidedJobPostsCount: number;
  modal: Omit<ComponentPropsWithoutRef<typeof Modal>, 'children'>;
  close: () => void;
};

export default function CompaniesDeleteModal({
  companyId,
  availableProvidedJobPostsCount,
  modal,
  close,
}: Props) {
  const { mutateAsync: deleteCompany, isPending } = useDeleteCompany();
  const hasAvailableJobPosts = availableProvidedJobPostsCount > 0;

  const handleDelete = async () => {
    try {
      await deleteCompany({ companyId });
      showSuccessToast('削除リクエストを受け付けました。しばらくしてから削除が完了します。');
      // 少し待ってから一覧ページにリダイレクト
      setTimeout(() => {
        window.location.href = '/agent/companies';
      }, 1000);
    } catch (error) {
      showErrorToast('削除に失敗しました');
    }
  };

  return (
    <Modal {...modal}>
      <div className="w-[728px] rounded bg-white">
        <div className="flex h-[53px] items-center gap-1 border-b border-solid border-border px-6">
          <img src="/agent/candidates/icon-warning.svg" width={20} height={20} alt="" />
          <p className="text-sm font-bold text-danger">ご注意ください</p>
        </div>
        <div className="border-b border-solid border-border p-6">
          <div className="flex flex-col gap-3">
            {hasAvailableJobPosts && (
              <p className="text-base font-bold text-danger">
                ⚠️ この企業には有効な求人が{availableProvidedJobPostsCount}
                件存在します。削除すると、これらの求人と関連するマッチングデータも全て削除されます。
              </p>
            )}
            <p className="text-base">
              企業を削除すると、求人データ、マッチングデータ含む関連する全てのデータが削除されます。
              削除した情報は復元できません。
            </p>
          </div>
        </div>
        <div className="flex h-[74px] items-center justify-end gap-4 px-6">
          <div className="w-[94px]">
            <BlockButton
              type="button"
              colorType="white"
              text="キャンセル"
              onClick={close}
              disabled={isPending}
            />
          </div>
          <div className="w-[180px]">
            <BlockButton
              type="button"
              colorType="red"
              text={isPending ? '送信中...' : '削除リクエストを送信'}
              onClick={handleDelete}
              disabled={isPending}
            />
          </div>
        </div>
      </div>
    </Modal>
  );
}
